var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['party-button', _vm.selected ? 'selected' : '', _vm.italic ? 'italic' : '', _vm.big ? 'big' : '', _vm.arrowed ? 'arrowed' : '']},[_vm._v(" "+_vm._s(_vm.caption)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }